import React from 'react'

function SuccessIcon(): JSX.Element {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M0 15C0 6.72 6.72 0 15 0C23.28 0 30 6.72 30 15C30 23.28 23.28 30 15 30C6.72 30 0 23.28 0 15ZM6.25002 15L12.5 21.25L23.75 9.99999L21.9875 8.22499L12.5 17.7125L8.01252 13.2375L6.25002 15Z"
        fill="#4AB289"
      />
    </svg>
  )
}

export default SuccessIcon
